import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren, useContext, useEffect } from 'react';
import styled from 'styled-components';
import Text from '../../common/base/Text';
import { Div } from '../../common/helpers/StyledUtils';
import { OutpostContext } from './OutpostContext';
import { StyledCard } from '../../common/base/Card';
import Container from '../../common/base/Container';
const StyledOverlayLoading = styled(Div)`
  position: absolute;
  height: 100vh;
  width: 100%;
  pointer-events: none;
  background-color: ${({
  theme
}) => theme.colors.surface.base.backdrop};
  z-index: ${({
  theme
}) => theme.zindex.sticky + 1};
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Covers the Outpost pages while the deployment is provisioned. The overlay only blurs them, so
// the pages themselves are made inert: nothing under it can be clicked, focused, selected or
// read by a screen reader until the deployment is ready. The nav sits outside, so the user can
// still switch projects.
const OutpostInitializingOverlay: React.FC<PropsWithChildren> = t0 => {
  const $ = _c(12);
  const {
    children
  } = t0;
  const {
    status
  } = useContext(OutpostContext);
  const is_initializing = status?.status === "INITIALIZING";
  let t1;
  let t2;
  if ($[0] !== is_initializing) {
    t1 = () => {
      if (!is_initializing || typeof document === "undefined") {
        return;
      }
      const previous_overflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = previous_overflow;
      };
    };
    t2 = [is_initializing];
    $[0] = is_initializing;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== is_initializing) {
    t3 = is_initializing && <StyledOverlayLoading role="status"><Container small={true}><StyledCard p={4} raised={true} flex={{
          direction: "column",
          align: "center",
          gap: 4
        }}><Text size="l" shimmering={true}>Initializing your Outpost deployment...</Text></StyledCard><Text size="xs" muted={true} center={true} m={{
          t: 4
        }}>This may take up to a minute.</Text></Container></StyledOverlayLoading>;
    $[3] = is_initializing;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "contents"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== is_initializing) {
    t5 = <Div inert={is_initializing} aria-busy={is_initializing} style={t4}>{children}</Div>;
    $[6] = children;
    $[7] = is_initializing;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default OutpostInitializingOverlay;